// extracted by mini-css-extract-plugin
export default {"image-container":"GPIs5d","imageContainer":"GPIs5d","image-wrapper":"ZmRmfi","imageWrapper":"ZmRmfi","image":"MV2yYE"};